import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";

import { TailscaleAccesses } from "./accesses.ts";
import { TailscaleComponents } from "./components.ts";

// Rule filter values compile to regular expressions, so a rule can say, e.g.,
// that any posture matching `posture:p0_prod_.*` needs approval. A rule picks
// the access type with its own `accessType`, so the type isn't a filter.
const TailscaleFilters = {
  target: { keys: ["name"] },
  tailnet: { keys: ["name"] },
} as const satisfies AnyFilterSchema;
export type TailscaleFilters = typeof TailscaleFilters;

// Keyed by component, so a new component doesn't compile until it has one.
// The new item's form labels an item's id with its component's kind, then
// this: "Connector ID", "Tailnet ID".
const IDENTIFIERS: Record<keyof typeof TailscaleComponents, string> = {
  connector: "ID",
  tailnet: "ID",
};
// `Registration` can hand `identifier` a string that isn't a component key.
const identifiers: Partial<Record<string, string>> = IDENTIFIERS;

export const TailscaleRegistration = Registration({
  accesses: TailscaleAccesses,
  category: "resource",
  components: TailscaleComponents,
  docs: { install: "tailscale", request: "tailscale/requesting-access" },
  filters: TailscaleFilters,
  identifier: (component) => identifiers[component] ?? component,
  // Each component is named for what one of its items is.
  itemKind: (component) => component,
  label: "Tailscale",
  logoUrl: "https://tailscale.com/favicon.ico",
  maturity: "beta",
  requestType: "requestable",
  useMapping: [{ component: "tailnet", use: "iam_write" }],
});

registerIntegration("tailscale", TailscaleRegistration);
